module.exports = __webpack_public_path__ + "img/1.8428bd87.png";